export function filteredComparators(selectedKey, currentIndex, keys) {
  // Get all other rows comparators that share the same key
    const otherComparators = keys
      .filter((item, index) => index !== currentIndex && item.key === selectedKey)
      .map((item) => item.comparator);

    const allComparators = ["lt", "lte", "gt", "gte"];

    // Filter out conflicting comparators
    return allComparators.filter((comparator) => {

      // Prevent selecting 'lt' and 'lte' simultaneously
      if (["lt", "lte"].includes(comparator) && otherComparators.some((c) => ["lt", "lte"].includes(c))) {
        return false;
      }

      // Prevent selecting 'gt' and 'gte' simultaneously
      if (["gt", "gte"].includes(comparator) && otherComparators.some((c) => ["gt", "gte"].includes(c))) {
        return false;
      }

      return true;
    });
}

export const comparatorMap = {
  lt: "Less Than (lt)",
  lte: "Less Than or Equal (lte)",
  gt: "Greater Than (gt)",
  gte: "Greater Than or Equal (gte)",
};

export function getComparatorText(comparator) {
  return comparatorMap[comparator] || comparator;
}

export function availableKeysForField(index, selectedKey, catalogItems) {
  const keys = Object.keys(catalogItems[0]?.item)
  const availableKeys = keys.filter(key => {
    if(this.selectedKeys[key] > 1 ){
      if(selectedKey === key)
        return true
      else return false
    }
    else return true
  })
  return availableKeys
}
export function comparatorRules(index, keys) {
  return [
    () => {
      const { comparator, key, date } = keys[index];
      const comparators = keys.filter((k) => k.key === key);
      const ltValues = comparators.filter((c) => c.comparator === "lt" || c.comparator === "lte");
      const gtValues = comparators.filter((c) => c.comparator === "gt" || c.comparator === "gte");

      if (key && date && !comparator) {
        return `${this.$vuetify.lang.t("$vuetify.ai_response.comparison_operator")} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
      }

      if (ltValues.length && gtValues.length) {
        const ltDate = ltValues[0]?.date;
        const gtDate = gtValues[0]?.date;
        const ltComparator = ltValues[0]?.comparator;
        const gtComparator = gtValues[0]?.comparator;
      
        const lt = new Date(ltDate).getTime();
        const gt = new Date(gtDate).getTime();
      
        if (gt >= lt) {
          return `The selected ${gtComparator} value must not exceed or equal to the ${ltComparator} value`;
        }
      }
      

      return true;
    },
  ];
}
export function keyRules(key, comparator, date) {
  return [
    () => {
      if ((date || comparator) && !key) {
        return `${this.$vuetify.lang.t("$vuetify.ai_response.key")} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
      }
      return true;
    },
  ];
}
export function dateRules(key, comparator, date) {
  return [
    () => {
      if (key && !date) {
        return `${this.$vuetify.lang.t("$vuetify.ai_response.date")} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
      }
      return true;
    },
  ];
}